import { ZpayProductReviewAttachment } from '@croquiscom-pvt/web2app';

export enum ThumbnailSize {
  SMALL = 'small',
  LARGE = 'large',
}

export type ReviewItemCardAttachment = ZpayProductReviewAttachment;

export type FulfillmentBadge = {
  type: string | null;
  text: string | null;
  image_url: string;
  image_size: {
    width: number;
    height: number;
  } | null;
};
